<script>
import CardValidator from 'card-validator'
import CardTypes from '@components/card-types'
import { propertyComputed } from '@state/helpers'

export default {
  components: { CardTypes },
  props: {
    dropdown: { type: Object, required: true },
    invalid: { type: Boolean, default: false },
  },
  data: () => ({
    form: {
      cardNumber: '',
      cardType: '',
      cardName: '',
      cardExpMonth: '',
      cardExpYear: '',
      cardCvv: '',
    },
  }),
  computed: {
    ...propertyComputed,
  },
  watch: {
    'form.cardNumber'(val) {
      const { isValid, card } = CardValidator.number(val)
      this.form.cardType = isValid && card ? card.type : ''
    },
  },
}
</script>

<template>
  <div class="flex flex-wrap">
    <BaseInput
      v-model="form.cardNumber"
      type="number"
      class="md:w-1/2"
      label="Card number"
      rules="required|card_number"
    />
    <!-- card number -->

    <BaseInput
      v-model="form.cardName"
      class="md:w-1/2"
      label="Name on card"
      rules="required|min:3"
    />
    <!-- card name -->

    <CardTypes class="w-full lg:w-1/2" :selected="form.cardType" />

    <div class="w-full lg:w-1/2">
      <div class="flex flex-wrap">
        <div class="w-1/3">
          <BaseSelect
            v-model="form.cardExpMonth"
            label="Month"
            rules="required|card_exp_month:year"
            :items="dropdown.cardExp.month"
          />
          <!-- card expired month -->
        </div>
        <div class="w-1/3">
          <BaseSelect
            v-model="form.cardExpYear"
            label="Year"
            rules="required|card_exp_year"
            :items="dropdown.cardExp.year"
          />
          <!-- card expired year -->
        </div>
        <div class="w-1/3">
          <BaseInput
            v-model="form.cardCvv"
            type="password"
            label="CVV"
            rules="required|card_cvv:cardNumber"
          />
          <!-- card cvv -->
        </div>
      </div>
    </div>
    <!-- card expired -->

    <!-- <div class="px-3 w-full">
        <p class="text-sm italic">
          By clicking the confirm reservation button below to submit this
          booking, I agree to {{ property.name }} Terms of Use and Privacy
          Policy.
        </p>
      </div> -->
    <!-- agreement -->
  </div>
  <!-- <div class="flex justify-center md:justify-end py-4 px-3">
      <button
        type="submit"
        :class="['btn', { 'btn-disabled': invalid }, 'btn-gold']"
        :disabled="invalid"
      >
        Confirm Reservation
      </button>
    </div> -->
</template>
